// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"ceec85dbd1aaaccbce16","993":"72aa8de50ceab0cd7309"}[chunkId] + ".js");